import React from 'react'
import spinner from './img/spinner.gif'

const Spinnner = () => {
    return (
        <img src={spinner} style={{width:"200px",margin:"auto",display:"block"}}/>
    )
}

export default Spinnner
